/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type IssueHierarchyDirectory from '@jira/spa-apps__admin-pages-issue-types-issue-hierarchy-directory/src/IssueHierarchyDirectory.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyIssueHierarchyDirectory: LazyComponent<
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(props: Record<any, any>) => React.JSX.Element
> = lazyForPaint<typeof IssueHierarchyDirectory>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-issue-hierarchy-directory", jiraSpaEntry: "async-admin-pages-issue-hierarchy-directory" */ '@jira/spa-apps__admin-pages-issue-types-issue-hierarchy-directory/src/IssueHierarchyDirectory.tsx'
		),
	),
);

const AsyncIssueHierarchyDirectory = (): React.JSX.Element => (
	<LazyPage
		Page={LazyIssueHierarchyDirectory}
		pageId="jira-admin-pages-issue-hierarchy-directory"
		shouldShowSpinner
	/>
);

export default AsyncIssueHierarchyDirectory;
